(() => {
  const init = root => root.querySelectorAll('[data-kokonote-scenes]').forEach(group => {
    if (group.hasAttribute('data-kokonote-ready')) return;
    const tabs = [...group.querySelectorAll('[data-kokonote-tab]')];
    const panels = [...group.querySelectorAll('[data-kokonote-panel]')];
    const holder = group.querySelector('.koko-panels');
    if (!tabs.length || !holder) return;
    let active = 0;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let frame;
    const resize = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => { holder.style.height = `${panels[active].getBoundingClientRect().height}px`; });
    };
    const select = (index, focus = false) => {
      active = index;
      tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index));tab.tabIndex = i === index ? 0 : -1;});
      panels.forEach((panel, i) => {
        panel.hidden = i !== index;
        if (i !== index) panel.querySelectorAll('video').forEach(v => v.pause());
        else panel.querySelectorAll('[data-device]:not([hidden]) video').forEach(v => {
          if (!reduced.matches && v.getBoundingClientRect().top < innerHeight && v.getBoundingClientRect().bottom > 0) v.play().catch(() => {});
        });
      });
      resize();
      if (focus) tabs[index].focus();
    };
    group.setAttribute('data-kokonote-ready', '');
    tabs.forEach((tab, i) => {
      const detail = tab.querySelector('.nf-pdp__detail');
      if (detail) panels[i].dataset.caption = detail.textContent;
      tab.addEventListener('click', () => select(i));
      tab.addEventListener('keydown', e => {
        let next;
        if (['ArrowRight','ArrowDown'].includes(e.key)) next = (i + 1) % tabs.length;
        if (['ArrowLeft','ArrowUp'].includes(e.key)) next = (i + tabs.length - 1) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next !== undefined) {e.preventDefault();select(next,true);}
      });
    });
    const observer = new ResizeObserver(resize);
    panels.forEach(panel => observer.observe(panel));
    select(0);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
(() => {const start=()=>{const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}}),{threshold:.3});document.querySelectorAll('[data-kokonote-reveal]').forEach(el=>observer.observe(el));};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();})();
